import { removeAndCleanLink } from "@/utils/helper"

const FALLBACK_PAGE_TYPE = "page"
const FALLBACK_ZONE = "manual slider"

const getPageType = () => {
  if (typeof window === "undefined") {
    return FALLBACK_PAGE_TYPE
  }

  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}

  return (
    page?.category?.pageType ||
    page?.pageInfo?.contentType ||
    window?.eventPageType ||
    FALLBACK_PAGE_TYPE
  )
    .toString()
    .toLowerCase()
}

const normalizeText = text => {
  return (text || "").toString().trim().toLowerCase()
}

const getAnalyticsUrl = link => {
  if (typeof window === "undefined" || !link) {
    return "n/a"
  }

  const cleanedLink = removeAndCleanLink(link)

  if (/^https?:\/\//i.test(cleanedLink)) {
    return cleanedLink
  }

  if (cleanedLink.startsWith("#")) {
    return `${window.location.origin}${window.location.pathname}${cleanedLink}`
  }

  return `${window.location.origin}${
    cleanedLink.startsWith("/") ? "" : "/"
  }${cleanedLink}`
}

const getClickInternalLinks = link => {
  if (typeof window === "undefined" || !link) {
    return "true"
  }

  const cleanedLink = removeAndCleanLink(link)

  if (cleanedLink.startsWith("/") || cleanedLink.startsWith("#")) {
    return "true"
  }

  if (!/^https?:\/\//i.test(cleanedLink)) {
    return "true"
  }

  return cleanedLink.includes(window.location.hostname) ? "true" : "false"
}

export const getManualSliderContainerAnalytics = sliderTitle => {
  const pageType = getPageType()
  const normalizedTitle = normalizeText(sliderTitle) || "rm"

  return JSON.stringify({
    eventName: `${pageType}:carousel:interaction`,
    eventAction: `${pageType}:carousel:interaction`,
    internalLinkName: `carousel:${normalizedTitle}`,
    internalLinkType: `${pageType}:manual slider`,
    internalLinkZoneName: `${pageType}:carousel`,
    clickInternalLinks: "true",
    eventType: "carousel",
    internalLinkURL: "n/a",
    internalLinkPosition: `${pageType}:carousel`,
  })
}

export const getManualSliderControlAnalytics = ({
  sliderTitle,
  controlName,
}) => {
  const pageType = getPageType()
  const normalizedSliderTitle = normalizeText(sliderTitle) || "rm"
  const normalizedControlName = normalizeText(controlName) || "rm"

  return JSON.stringify({
    eventName: `${pageType}:carousel:interaction`,
    eventAction: `${pageType}:carousel:interaction`,
    internalLinkName: `carousel:${normalizedControlName}`,
    internalLinkType: `${pageType}:manual slider`,
    internalLinkZoneName: `${pageType}:${normalizedSliderTitle}`,
    clickInternalLinks: "true",
    eventType: "carousel",
    internalLinkURL: "n/a",
    internalLinkPosition: `${pageType}:carousel`,
  })
}

export const getManualSliderLinkAnalytics = ({
  link,
  linkName,
  sliderTitle,
}) => {
  const pageType = getPageType()
  const normalizedLinkName = normalizeText(linkName) || "rm"
  const normalizedSliderTitle = normalizeText(sliderTitle) || FALLBACK_ZONE

  return JSON.stringify({
    clickInternalLinks: getClickInternalLinks(link),
    internalLinkPosition: `${pageType}:${FALLBACK_ZONE}`,
    internalLinkZoneName: `${pageType}:${normalizedSliderTitle}`,
    internalLinkURL: getAnalyticsUrl(link),
    internalLinkName: normalizedLinkName,
    eventName: `${pageType}:${normalizedSliderTitle}:${normalizedLinkName}`,
    internalLinkType: `${pageType}:manual slider`,
    eventType: "teaser",
    eventAction: `${pageType}:${normalizedSliderTitle}:${normalizedLinkName}`,
    eventMsg: "n/a",
    eventStatus: "n/a",
  })
}
